import React, { useState } from 'react';
import styled from 'styled-components/macro';

import formatNumber from 'helpers/formatNumber';
import getNumberColor from 'helpers/getNumberColor';

import Box from 'components/elements/Box';
import CountryFlag from 'components/base/CountryFlag';
import P from 'components/elements/p';

import colors from 'styles/themes/colors';

import {
  TableRow,
  Cell,
  StyledCaret,
  StyledCaretWrap,
} from 'components/data-containers/BrowseEntities/BrowseTableRow/BrowseTableRow.style';

import {
  CellContent as Content,
  SecondaryValue,
} from 'components/data-visualization/Table/DoubleMetricCell.style';

import { TableHeader } from 'components/data-containers/BrowseEntities/shared/types';

const CellContent = styled('td')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex-grow: 1;
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.xxsmall}`};
`;

export const MobileCell = styled('tr')`
  width: 100%;

  ${CellContent} {
    justify-content: space-between;
  }
`;

interface IBrowseTableRowProps {
  entityData?: any;
  tableHeaders: TableHeader[];
  territory?: any;
}

const MobileTableRow: React.FC<IBrowseTableRowProps> = (props) => {
  const { entityData, tableHeaders, territory } = props;

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <TableRow
      isExpanded={isExpanded}
      onClick={(): void => setIsExpanded(!isExpanded)}
    >
      <CellContent>
        <Box display="flex" alignItems="center">
          <CountryFlag
            id={territory.id || territory.countryId}
            displayName={territory.countryName}
            flagImgSmall={territory.flagImgSmall}
            flagImgMedium={territory.flagImgMedium}
            flagImgLarge={territory.flagImgLarge}
            small
          />
          <P fontSize="13.33px" fontWeight={600}>
            {territory?.countryName}
          </P>
        </Box>

        {isExpanded &&
          tableHeaders.map((header: any) => {
            const value = (entityData as any)[header.value];
            const isChange =
              header.value === 'wowInProgress' ||
              header.value === 'wowLastCompleted';
            const valueFormat = isChange ? 'percentage' : 'number';
            const hasColor = getNumberColor(value);

            return (
              <Content
                paddingRight="2em"
                isRightAligned
                isCentered={false}
                justifyContent="flex-start"
                key={Object.values(header).join('-')}
              >
                <P my={2} fontSize="13.33px">
                  {header?.label}
                </P>

                <SecondaryValue
                  hasColor={isChange ? hasColor : colors.DeepBlue}
                  marginLeft="1rem"
                  fontSize="13.33px"
                >
                  {value ? formatNumber(value, valueFormat, true) : '-'}
                </SecondaryValue>
              </Content>
            );
          })}
      </CellContent>

      <Cell open={isExpanded}>
        <StyledCaretWrap>
          <StyledCaret
            open={isExpanded}
            onClick={(): void => setIsExpanded(!isExpanded)}
          />
        </StyledCaretWrap>
      </Cell>
    </TableRow>
  );
};

export default MobileTableRow;
